(function (window) {
  'use strict';

  const activeJSViewClass = 'js-view--active';
  const activeViewClass = 'view--active';
  const hiddenViewClass = 'view--hidden';
  const nextViewClass = 'js-view--next';

  function initInstance(instance) {
    const views = Array.prototype.filter.call(instance.children, child => child.classList.contains('js-view'));

    instance.addEventListener('resetView', resetView);

    for (let i = 0; i < views.length; i++) {
      views[i].addEventListener('activateView', handleView);
    }
  }

  function resetView(e) {
    const wrapper = e.currentTarget;
    const def = Array.prototype.filter.call(wrapper.children, child => child.classList.contains('js-view--default'))[0];

    def.dispatchEvent(new CustomEvent('activateView', {detail: {reset: true}}));
  }

  function handleView(e) {
    const next = e.target;
    const instance = next.closest('.js-views-wrapper');
    const current = Array.prototype.filter.call(instance.children, child => child.classList.contains(activeJSViewClass))[0];

    if(e.detail !== null && e.detail.hasOwnProperty('reset') && e.detail.reset) { // If resetting views, the modal is closed so we cannot rely on transitionend events
      if(next !== current) {
        // Hide current view
        current.classList.add(hiddenViewClass);
        current.classList.remove(activeViewClass);
        current.classList.remove(activeJSViewClass);

        // Show next view
        next.classList.add(activeViewClass);
        next.classList.add(activeJSViewClass);
        next.classList.remove(hiddenViewClass);

        // Force reflow !important
        next.offsetWidth;
      }
    } else { // Otherwise, if the modal is open
      if (next !== current) { // If current and next view are not the same
        // Hide current view
        current.classList.add(hiddenViewClass);
        // Mark next view
        next.classList.add(nextViewClass);

        // Wait for current view to hide
        setTimeout(() => {
          switchView(next, current)
        }, 400);
      } else { // Otherwise trigger completion event
        triggerActivatedView(e);
      }
    }
  }

  function triggerActivatedView(e) {
    e.currentTarget.dispatchEvent(new CustomEvent('viewActivated'));
  }

  function switchView(next, current) {
    // Switch active view
    current.classList.remove(activeViewClass);
    current.classList.remove(activeJSViewClass);
    next.classList.add(activeViewClass);
    next.classList.add(activeJSViewClass);

    // Force reflow !important
    next.offsetWidth;

    // Animate next view and unmark it
    next.classList.remove(nextViewClass);
    next.classList.remove(hiddenViewClass);


    setTimeout(() => {
      triggerActivatedView({currentTarget: next});
    }, 400);
  }

  function init() {
    const instances = document.querySelectorAll('.js-views-wrapper');

    for (let i = 0; i < instances.length; i++) {
      if (!instances[i].classList.contains('js-component-init')) {
        initInstance(instances[i]);

        instances[i].classList.add('js-component-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
